<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Detalhe da Fase"
                @click.stop="abrirModalAtualizarDetalheEntrega()"
            ></i>
        </span>
        <b-modal
            id="modalAtualizarDetalheEntrega"
            v-model="mostrarModalAtualizarDetalheEntrega"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Detalhe da Fase do Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O que deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group v-model="contratoApostilamento"  @change="alternaJustificativa($event)">
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Produto</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="2"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>
                            <span v-if="!$v.descricao.required"
                                >O produto é obrigatório</span
                            >
                            <span v-if="!$v.descricao.maxLength"
                                >A quantidade máxima de caracteres é 100</span
                            >
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group
                        :state="$v.mesPrevisto.$error ? false : null"
                        invalid-feedback="Mês previsto é obrigatório"
                    >
                        <label>Mês Previsto</label>
                        <date-picker
                            v-model="mesPrevisto"
                            :config="$monthPickerOptions"
                            v-mask="'##/####'"
                            @input.native="$v.mesPrevisto.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        invalid-feedback="Valor é inválido"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{textoInfoJustificativa}} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalAtualizarDetalheEntrega()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarDetalheFase()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import {
    required,
    minValue,
    maxValue,
    maxLength
} from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        detalhe: {
            type: Object,
            default: () => ({})
        },

        fase: {
            type: Object,
            default: () => ({})
        },

        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModalAtualizarDetalheEntrega: false,
            obterDetalhesFaseAtualizados: false,
            operacao: 'ATUALIZAÇÃO',
            erros: [],
            descricao: '',
            valor: 0,
            mesPrevisto: null,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        abrirModalAtualizarDetalheEntrega() {
            this.mostrarModalAtualizarDetalheEntrega = true
        },

        fecharModalAtualizarDetalheEntrega() {
            this.mostrarModalAtualizarDetalheEntrega = false
            this.resetAtualizarDetalheEntrega()
            if (this.obterDetalhesFaseAtualizados) {
                this.$emit('obterDetalhesFaseAtualizados')
            }
        },

        resetAtualizarDetalheEntrega() {
            this.justificativaApostilamento = ''
            this.descricao = ''
            this.valor = 0
            this.mesPrevisto = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterDetalhesFaseAtualizados = false
            this.descricao = this.detalhe.descricao.trim()
            this.valor = this.detalhe.valor
            this.mesPrevisto = this.$moment(this.detalhe.mesPrevisto).format(
                'MM/YYYY'
            )
        },

        confirmarSalvarDetalheFase() {
            this.$swal({
                title: 'Detalhe da Fase do Contrato',
                html: `Confirma a atualização do detalhe da fase <b>${this.fase.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarDetalheFase()
                }
            })
        },

        salvarDetalheFase() {
            this.$store.dispatch('addRequest')
            let detalheFaseAtualizadoDto = {
                idContrato: this.$route.params.contratoId,
                detalheFaseContratoId: this.detalhe.detalheFaseContratoId,
                faseContratoId: this.detalhe.faseContratoId,
                descricao: this.descricao,
                valor: this.valor,
                mesPrevisto: this.$moment(
                    '01/' + this.mesPrevisto,
                    'DD/MM/YYYY'
                ),
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.atualizarDetalheFaseEntrega(
                detalheFaseAtualizadoDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterDetalhesFaseAtualizados = true
                        this.fecharModalAtualizarDetalheEntrega()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registrosInalterados() {
            if (this.descricao) {
                return (
                    this.descricao.trim() == this.detalhe.descricao.trim() &&
                    this.valor == this.detalhe.valor &&
                    this.mesPrevisto ==
                        this.$moment(this.detalhe.mesPrevisto).format('MM/YYYY')
                )
            }
            return false
        },

        valorIncorreto() {
            if (this.valor > this.detalhe.valor + this.fase.disponivel) {
                return false
            }
            return true
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido())
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if(this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if((this.apostilamento || this.atualizacaoContrato()) && this.contratoApostilamento != null) {
                return true
            } else if(this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if(this.$temAcessoView('CONT-ATUALIZAR-00') && this.$temAcessoView('CONT-APOST-06')) {
                this.contratoApostilamento = null
            } else if(this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if(this.$temAcessoView('CONT-APOST-06')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }

    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return (
                this.atualizacaoContrato() && this.apostilamento
            )
        },
    },

    watch: {},

    validations: {
        detalheFaseContratoId: {
            registrosAlterados() {
                return !this.registrosInalterados()
            }
        },
        descricao: {
            required,
            maxLength: maxLength(100)
        },
        valor: {
            required,
            valorIncorreto() {
                return this.valorIncorreto()
            },
            minValue: minValue(0.01)
        },
        mesPrevisto: {
            required
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
